// @flow
export const TREATMENT_DETAILS_REQUEST = 'TREATMENT_DETAILS_REQUEST';
export const TREATMENT_DETAILS_UPDATE = 'TREATMENT_DETAILS_UPDATE';
export const TREATMENT_DETAILS_ERROR = 'TREATMENT_DETAILS_ERROR';
export const TREATMENT_DETAILS_RESET = 'TREATMENT_DETAILS_RESET';
